/* BYAARA Wishlist Registry v1 — metadata only; nt_wis remains canonical. */
(function () {
  'use strict';
  if (window.__byaaraWishlistRegistryInstalled) return;
  window.__byaaraWishlistRegistryInstalled = true;
  const registryKey = 'byaara_wishlist_registry_v1';
  const wishlistSelector = '[data-bpr-wishlist],[data-bcp-wishlist],[data-favorite],[data-premium-product-wishlist]';
  const cardSelector = '[data-bpr-card],[data-bcp-card],.fcx__card,.wwsv__card,[data-wwsv-card],article,li';
  const read = () => {
    try { const data = JSON.parse(localStorage.getItem(registryKey) || '{}'); return data && typeof data === 'object' && !Array.isArray(data) ? data : {}; }
    catch (_) { return {}; }
  };
  function cleanProductUrl(value) {
    if (!value) return null;
    try {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin || !/\/products\/[^/]+/.test(url.pathname)) return null;
      return url.pathname + (url.search || '');
    } catch (_) { return null; }
  }
  function capture(button) {
    const id = String(button.dataset.bprWishlist || button.dataset.bcpWishlist || button.dataset.favorite || button.dataset.productId || '');
    if (!/^\d+$/.test(id)) return;
    const card = button.closest(cardSelector);
    const link = card && card.querySelector('a[href*="/products/"]');
    const url = cleanProductUrl(button.dataset.productUrl || (card && (card.dataset.productUrl || card.dataset.bprProductUrl)) || (link && link.href));
    const matched = url && url.match(/\/products\/([^/?#]+)/);
    if (!matched) return;
    const handle = decodeURIComponent(matched[1]);
    const image = (card && card.querySelector('img[src]')) || null;
    const title = button.dataset.productTitle || button.dataset.bprWishlistTitle || button.dataset.bcpWishlistTitle || (card && card.dataset.productTitle) || (link && (link.getAttribute('aria-label') || link.textContent)) || '';
    const priceNode = card && card.querySelector('.bpr__price,.bcp__price,.fcx__price,.wwsv__price,[data-product-price]');
    const data = read();
    data[id] = {
      id, handle, url,
      title: String(title).replace(/^View\s+/i, '').trim().slice(0, 300),
      image: (image && (image.currentSrc || image.src)) || button.dataset.productImage || '',
      price: (priceNode && priceNode.textContent.trim()) || button.dataset.productPrice || '',
      recordedAt: Date.now()
    };
    // Preserve recent product details, without ever touching the saved wishlist IDs.
    const entries = Object.entries(data).sort((a, b) => (b[1].recordedAt || 0) - (a[1].recordedAt || 0)).slice(0, 350);
    try { localStorage.setItem(registryKey, JSON.stringify(Object.fromEntries(entries))); }
    catch (_) { /* Registry is optional and cannot prevent wishlist usage. */ }
  }
  // Capture before the card's own wishlist handler runs, including remove/add events.
  document.addEventListener('click', event => {
    const button = event.target.closest(wishlistSelector);
    if (button) capture(button);
  }, true);
  // Also cache visible cards so previously saved products can resolve after revisiting a collection.
  let scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll(wishlistSelector).forEach(capture);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if ('requestIdleCallback' in window) window.requestIdleCallback(scan, {timeout: 1600});
    else window.setTimeout(scan, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once: true});
  else schedule();
  const observer = new MutationObserver(mutations => {
    if (mutations.some(m => m.addedNodes && m.addedNodes.length)) schedule();
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', schedule);
})();
